import 'client-only';

import { type Brand } from '@/consts/brands';
import { type RegistrationEligibilityDataType } from '@/types/eligibility/eligibility';
import { type AnalyticsPatientResource } from '@/types/metrics/analyticsPatient';
import { type HttpError, type HttpResponse, post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

import { type StoreRegistrationData, type LoginData } from './types';

export type RegistrationErrorType = HttpError<{
  message?: string;
  errors: {
    email?: string[];
    password?: string[];
    isMismatchedBrand?: string[];
    isInvalidSparkPost?: string[];
    accountAlreadyExistsForBrand?: string[];
  };
}>;

export type RegistrationResponseType = HttpResponse<{
  user?: AnalyticsPatientResource;
  isDeletingBrandAccount?: true;
  canTransferBrand?: true;
  recognizedEmail?: string;
  requestPassword?: boolean;
}>;

const register = (data: StoreRegistrationData, brand: Brand) =>
  post(urls[brand].api.registration.store, data);

const completeBrandTransfer = (data: StoreRegistrationData, brand: Brand) =>
  post(urls[brand].api.registration.completeBrandTransfer, data);

const login = (data: LoginData, brand: Brand) =>
  post(urls[brand].api.auth.login, data);

const funnelBrandTransfer = (
  data: RegistrationEligibilityDataType,
  brand: Brand,
) =>
  post(urls[brand].api.registration.funnelBrandTransfer, {
    dob: data.birthdate,
    state: data.state,
    acceptedTOS: data.hasAcceptedTerms,
  });

export const RegistrationService = {
  login,
  register,
  completeBrandTransfer,
  funnelBrandTransfer,
};
